module.exports = __webpack_public_path__ + "img/24.18fc69ed.png";